import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconPhotoAddComponent } from "./med-icon-photo-add.component";

@NgModule({
  declarations: [
    MedIconPhotoAddComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconPhotoAddComponent,
  ],
})
export class MedIconPhotoAddModule { }
